export enum FilterTypeEnum {
  date = 1,
  checkbox = 2,
  radio = 3,
  agencyFilter = 4,
  tierFilter = 5,
  onlineStoreFilter = 6,
  cityFilter = 7,
  customerFilter = 8,
  posFilter = 9,
  priceFilter = 10,
  amountFilter = 11,
  roleFilter = 12,
  assortmentFilter = 13,
  variantSize = 14,
  paletteFilter = 15,
  basicCollectionFilter = 16,
  inputFilter = 17,
  styleGroupFilter = 18,
  channelFilter = 19,
  productFilter = 20,
  userFilter = 21,
  seasonReferenceFilter = 22,
  voucherFilter = 23,
  showcasesFilter = 24,
  blockOrderTypeFilter = 25,
  commercialBlockTypeFilter = 26,
  customerGroupCodeFilter = 27,
  customerSubgroupCodeFilter = 28,
  customerSignBoardFilter = 29,
  customerHoldingFilter = 30,
  customerGroupFilter = 31,
  salesTaxGroupFilter = 32,
  ordersFilter = 33,
  hasDesignerNotification = 34,
  byCustomizationRequest = 35
}
